import { Share as CapacitorShare } from '@capacitor/share';
import Analytics from '@withlocals/withlocals-analytics';
import { WlWindow } from 'typings/globals/cordova';

declare const window: WlWindow;

export const getShareOption = (): 'social-share' | 'navigator' | 'none' => {
  if (!!CapacitorShare.share) {
    return 'social-share';
  }
  if (window.navigator && window.navigator.share) {
    return 'navigator';
  }
  return 'none';
};

const Share = async ({
  message,
  subject,
  url,
  chooserTitle,
  analyticsCategory,
}) => {
  const shareOption = getShareOption();

  const options = {
    text: message,
    title: subject,
    url,
    dialogTitle: chooserTitle,
  };

  switch (shareOption) {
    case 'social-share':
      try {
        const { activityType } = await CapacitorShare.share(options);
        Analytics.track(analyticsCategory, 'Share', activityType);
        console.log('Shared to app: ' + activityType);
      } catch (error) {
        console.error('Error sharing', error);
      }
      break;
    case 'navigator':
      try {
        await window.navigator.share({
          options,
        });
        console.log('Successful share');
      } catch (error) {
        console.error('Error sharing', error);
      }
      break;
    default:
      return;
  }
};

const fbAppId = FB_APP_ID;

export function shareFacebook(link, redirectURI) {
  const fbUrl = `https://www.facebook.com/dialog/share?app_id=${fbAppId}&href=${encodeURIComponent(
    link,
  )}&redirect_uri=${encodeURIComponent(redirectURI)}`;

  window.open(fbUrl, 'fb', 'status=0,width=620,height=400');
}

export function shareFacebookMessenger(link, redirectURI) {
  const fbUrl = `https://www.facebook.com/dialog/send?app_id=${fbAppId}&link=${encodeURIComponent(
    link,
  )}&redirect_uri=${encodeURIComponent(redirectURI)}`;
  window.open(fbUrl, 'fb-messenger', 'status=0,width=620,height=400');
}

export function shareEmail(subject, body) {
  const url = `mailto:?subject=${encodeURIComponent(
    subject,
  )}&body=${encodeURIComponent(body)}`;
  // Firefox can error with protocol handlers
  let mailer = null;
  try {
    mailer = window.open(url, 'Mailer');
  } catch (e) {
    console.warn('There was an error opening a mail composer.', e);
  }

  setTimeout(() => {
    // This needs to be in a try/catch block because a Security
    // error is thrown if the protocols doesn't match
    try {
      // At least in Firefox the location is changed to about:blank
      if (
        mailer.location.href === url ||
        mailer.location.href.substr(0, 6) === 'about:'
      ) {
        mailer.close();
      }
    } catch (e) {
      console.warn('There was an error opening a mail composer.', e);
    }
  }, 500);
}

export function shareTwitter(body) {
  const url = `https://twitter.com/intent/tweet?text=${encodeURIComponent(
    body,
  )}`;

  window.open(url, 'twitter', 'status=1,width=575,height=400');
}

export default Share;
